<template>
  <span :style="{ width: width }" class="p-button-sort-base">
    <span class="p-button-sort-base__text">
      <slot></slot>
    </span>
    <i v-if="$slots.icon" class="p-button-sort-base__icon">
      <slot name="icon"></slot>
    </i>
  </span>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

@Options({
  props: {
    width: { type: String, default: "130px", required: false }
  }
})
export default class ButtonRefineBase extends Vue {
  width!: string;
}
</script>

<style lang="scss" scoped>
.p-button-sort-base {
  display: flex;
  justify-content: center;
  text-align: center;
  border: 1px solid $common-gray300;
  border-radius: rem(4);
  padding: rem(7) rem(8);
  width: 130px;
  min-height: rem(40);
  background-color: $common-white;

  &__text {
    color: #4f4f4f;
    font-size: rem(14);
    line-height: 1.6;
    display: block;
    position: relative;
    font-weight: bold;

    &.tap {
    }
  }

  &__icon {
    margin: 0 0 0 4px;
    display: flex;
    align-items: center;
  }
}
</style>
